import * as $ from 'jquery'
import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'
import 'jquery-validation/dist/localization/messages_pl'

import {Languages} from "../../Core/Languages";
import {PhonePLRule} from "../Validation/Rules/PhonePL.rule";
import {PostalPLRule} from "../Validation/Rules/PostalPL.rule";
import {CheckNipAndCompany} from "../Validation/Rules/CheckNipAndCompany";
import {CheckNipHasChanged} from "../Validation/Rules/CheckNipHasChanged";
import {NipRule} from "../Validation/Rules/Nip.rule";
import {PasswordRules} from "./Rules/PasswordRules";
import {CustomFileExtensionRules} from "./Rules/CustomExtensionRules"
import {CustomDepartmentIdRules} from "./Rules/CustomDepartmentIdRules"
import {FileMaxSizeRules} from './Rules/FileMaxSizeRules';

import {StrongPasswordRule} from "./Rules/StrongPassword.rule";
import ValidationOptions = JQueryValidation.ValidationOptions;

export const ValidationModule = (() => {
	interface customValidationOptions extends ValidationOptions {
		lang: string;
		normalizer: (string) => string,
	}

	$.extend( $.validator.messages, {
		reCaptcha: 'Pole reCAPTCHA musi być zaznaczone.',
		required_from_group: 'Proszę wypełnić przynajmniej jedno z pól: telefon, email'
	});

	const config: customValidationOptions = {
		onkeyup:      element => $(element).valid(),
		lang:         Languages.Current.key,
		errorElement: 'div',
		errorClass:   'invalid-feedback',
		normalizer:   value => $.trim(value),
		highlight:    (element, errorClass) => $(element).addClass('is-invalid').removeClass(errorClass),
		unhighlight:  (element, errorClass) => $(element).removeClass('is-invalid').removeClass(errorClass),
		errorPlacement: function(error, element) {
			error.appendTo(element.parent())
		}
	};

	$.validator.setDefaults(config);

	const rules = {
		StrongPasswordRule,
		PhonePLRule,
		PostalPLRule,
		NipRule,
		CheckNipAndCompany,
		CheckNipHasChanged,
		FileMaxSizeRules,
		CustomFileExtensionRules,
		CustomDepartmentIdRules
	};

    Object.assign({rules},
        new PasswordRules().passwordRule()
    )
})();
import * as $ from 'jquery'
import 'jquery-validation'
import 'jquery-validation/dist/additional-methods'
import 'jquery-validation/dist/localization/messages_pl'

import {Languages} from "../../Core/Languages";
import {PhonePLRule} from "../Validation/Rules/PhonePL.rule";
import {PostalPLRule} from "../Validation/Rules/PostalPL.rule";
import {CheckNipAndCompany} from "../Validation/Rules/CheckNipAndCompany";
import {CheckNipHasChanged} from "../Validation/Rules/CheckNipHasChanged";
import {NipRule} from "../Validation/Rules/Nip.rule";
import {PasswordRules} from "./Rules/PasswordRules";
import {CustomFileExtensionRules} from "./Rules/CustomExtensionRules"
import {CustomDepartmentIdRules} from "./Rules/CustomDepartmentIdRules"
import {FileMaxSizeRules} from './Rules/FileMaxSizeRules';

import {StrongPasswordRule} from "./Rules/StrongPassword.rule";
import ValidationOptions = JQueryValidation.ValidationOptions;

export const ValidationModule = (() => {
	interface customValidationOptions extends ValidationOptions {
		lang: string;
		normalizer: (string) => string,
	}

	$.extend( $.validator.messages, {
		reCaptcha: 'Pole reCAPTCHA musi być zaznaczone.',
		required_from_group: 'Proszę wypełnić przynajmniej jedno z pól: telefon, email'
	});

	const config: customValidationOptions = {
		onkeyup:      element => $(element).valid(),
		lang:         Languages.Current.key,
		errorElement: 'div',
		errorClass:   'invalid-feedback',
		normalizer:   value => $.trim(value),
		highlight:    (element, errorClass) => $(element).addClass('is-invalid').removeClass(errorClass),
		unhighlight:  (element, errorClass) => $(element).removeClass('is-invalid').removeClass(errorClass),
		errorPlacement: function(error, element) {
			error.appendTo(element.parent())
		}
	};

	$.validator.setDefaults(config);

	const rules = {
		StrongPasswordRule,
		PhonePLRule,
		PostalPLRule,
		NipRule,
		CheckNipAndCompany,
		CheckNipHasChanged,
		FileMaxSizeRules,
		CustomFileExtensionRules,
		CustomDepartmentIdRules
	};

    Object.assign({rules},
        new PasswordRules().passwordRule()
    )
})();
